module.exports = __webpack_public_path__ + "static/img/Viliame_Fifita.e156385.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Viliame_Fifita.jpg
// module id = O71Q
// module chunks = 0